<div class="add-vehicle-modal">
    <div mat-dialog-title>
        <div class="row">
            <div class="col-md-10">
                <h3>Phone Compatibility</h3>
            </div>
            <div class="col-md-2">
                <span class="fa fa-close action-icons float-right ml-auto" (click)="close()"></span>
            </div>
        </div>
    </div>

    <div mat-dialog-content>
        <div class="row">
            <div class="col-md-12 mt-2">
                <div class="row" *ngFor="let alert of alerts" class="padding-b-15">
                    <div class="alert alert-dismissible" [ngClass]="{'alert-danger': alert.type === 'error','alert-success': alert.type === 'success'}">
                        <button type="button" class="close" data-dismiss="alert" (click)="closeAlerts()">×</button>
                        {{ alert.msg }}
                    </div>
                </div>
            </div>
        </div>
        <div class=" row ">
            <mat-form-field class="col-md-10">
                <input matInput placeholder="Link URL" disabled name="linkName" #linkName1="ngModel" [(ngModel)]="editCompatibility.linkUrl">
            </mat-form-field>
        </div>
        <div class=" row ">
            <mat-form-field class="col-md-10">
                <input matInput placeholder="Display Name" required name="displayName" #displayName1="ngModel" [(ngModel)]="editCompatibility.displayName">
            </mat-form-field>
        </div>

        <div class="row ">
            <span *ngIf="editCompatibility.icon" class="step-icon-span image-thumbnail" style="margin-left: 15px;">
                <img [alt]="thumbnilPath+editCompatibility.icon" class="thumbnail" [src]="thumbnilPath+editCompatibility.icon" />
            </span>
            <input #compatibleIconUploader class="compatibleIconUploader" type="file" (click)="compatibleIconUploader.value=null" hidden
                name="avatar" (change)="onCompatibilityIconChange($event.target.files,'icon')" />

            <span class="float-right ml-auto" style="margin-right: 85px;">
                <button class="ml-2 btn btn-browse" type="button" (click)="uploadIcon()">{{ "Button.update_icon" | translate}}</button>
            </span>

        </div>


    </div>

    <div mat-dialog-actions class="dialog-actions">
        <span>
            <button class="btn btn-default" (click)="onSelect()">Ok</button>
        </span>
        <span class="ml-2">
            <button class="btn btn-secondary" (click)="onCancel()">Cancel</button>
        </span>
    </div>
</div>